import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import PreventiveHeartCare from "@/pages/PreventiveHeartCare";
import WomensHeartHealth from "@/pages/WomensHeartHealth";
import GeneralCare from "@/pages/GeneralCare";
import Team from "@/pages/Team";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/preventive-heart-care" element={<PreventiveHeartCare />} />
              <Route path="/womens-heart-health" element={<WomensHeartHealth />} />
              <Route path="/general-care" element={<GeneralCare />} />
              <Route path="/team" element={<Team />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
          </Routes>
        </SmoothScroll>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
